import { OrderItemInfo } from 'appTypes/orders'
import { LeidButtonWhiteOutlined, LeidRedButton, LeidYellowButton } from 'components/ui/Buttons/Button'
import { useTranslation } from 'react-i18next'
import { orderItemCanBeCanceled } from '../utils/orderItems'
import LeidModal from 'components/ui/Modal/LeidModal'
import { JSX, useState } from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { LuX } from 'react-icons/lu'
import apiClient from 'helpers/clients/apiClient'
import { useDispatch } from 'react-redux'
import { displaySnackbar } from 'store/partials/snackbar/snackbarSlice'

type Props = {
  orderItemInfo: OrderItemInfo
  refetchOrder: () => void
}

const OrderItemCancellButton = ({ orderItemInfo, refetchOrder }: Props): JSX.Element | null => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)

  const canBeCancelled = orderItemCanBeCanceled(orderItemInfo.orderItem)
  if (!canBeCancelled) {
    return null
  }

  const handleClose = () => {
    setIsOpen(false)
    setIsProcessing(false)
  }

  const handleOrderItemCancel = async () => {
    setIsProcessing(true)
    const response = await apiClient.cancelOrderItem(orderItemInfo.orderItem.id)
    if (response.data) {
      refetchOrder()
    } else {
      dispatch(displaySnackbar({ message: t('common:error'), isError: true }))
      setIsProcessing(false)
    }
  }

  const handleCancelButton = () => {
    setIsOpen(true)
  }

  return (
    <>
      <LeidRedButton onClick={handleCancelButton}>{t('cancelOrder')}</LeidRedButton>

      <LeidModal
        isOpen={isOpen}
        onClose={handleClose}
        size={{ mdDown: 'cover', md: 'xl' }}
        header={
          <Flex justifyContent="end" alignItems="center" width="100%">
            <LuX size={32} onClick={handleClose} />
          </Flex>
        }
      >
        <Text marginBottom={5}>
          {t('cancelOrderConfirmation', { productName: orderItemInfo.orderItem.productData?.name ?? '' })}
        </Text>
        <Flex direction="column" gap={5}>
          <LeidYellowButton onClick={handleOrderItemCancel} isDisabled={isProcessing}>
            {t('yes')}
          </LeidYellowButton>
          <LeidButtonWhiteOutlined isDisabled={isProcessing}> {t('no')}</LeidButtonWhiteOutlined>
        </Flex>
      </LeidModal>
    </>
  )
}

export default OrderItemCancellButton
